// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/bg-light.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.1rem !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 1rem !important;
}

.main-container {
  position: relative;
  background-color: #0d1116;
}

a {
  text-decoration: none;
}

a:hover {
  color: #5000ca;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

p, a, h1, h2, h3, h4, h5, label, button {
  color: white;
  font-family: "Lato", sans-serif;
}

.navigation-bar {
  justify-content: space-between;
  background-color: #0d1116;
}
.navigation-bar button {
  font-size: 1.1rem;
  font-family: "Lato", sans-serif;
  text-transform: initial;
  padding: 6px 10px;
}
.navigation-bar svg {
  cursor: pointer;
}

.navigation-bar-responsive span, .navigation-bar-responsive p {
  color: #0d1116;
  font-family: "Lato", sans-serif;
}

.container {
  margin-top: 64px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header-image {
  width: 100%;
  height: 450px;
}
.header-image img {
  width: 100%;
  height: 450px;
  object-fit: cover;
}

.mobile-menu-top {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-weight: bold;
}

.items-container {
  padding: 5% 10%;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.light-mode {
  background-color: #f8f9fa;
}
.light-mode .navigation-bar {
  background-color: #f8f9fa;
}
.light-mode p, .light-mode a, .light-mode h1, .light-mode h2, .light-mode h3, .light-mode h4, .light-mode h5, .light-mode label, .light-mode button {
  color: #0d1116;
}
.light-mode a:hover {
  color: #5000ca;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
.light-mode .navigation-bar svg {
  color: #0d1116;
}
.light-mode .about-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.light-mode .skills-container svg {
  color: #0d1116;
}
.light-mode .chip {
  background-color: rgba(0, 0, 0, 0.08);
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.light-mode .vertical-timeline::before {
  background-color: rgba(0, 0, 0, 0.08);
}
.light-mode .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.light-mode .vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {
  color: gray;
}
.light-mode .vertical-timeline-element-content-arrow {
  border-right: 7px solid rgba(0, 0, 0, 0.08) !important;
}
.light-mode .flex-chips .chip-title {
  color: #0d1116;
}

@media screen and (max-width: 768px) {
  .items-container {
    padding: 5% 5%;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;EACA,4BAAA;AADF;;AAIA;EACE,0FAAA;EACA,0BAAA;AADF;;AAIA;EACE,kBAAA;EACA,yBAAA;AADF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,cAAA;EACA,uGAAA;AAFF;;AAKA;EACE,YAAA;EACA,+BAAA;AAFF;;AAKA;EACE,8BAAA;EACA,yBAAA;AAFF;AAIE;EACE,iBAAA;EACA,+BAAA;EACA,uBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;;AAQE;EACE,cAAA;EACA,+BAAA;AALJ;;AASA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AANF;;AASA;EACE,WAAA;EACA,aAAA;AANF;AAQE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AANJ;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;AASE;EACE,yBAAA;AAPJ;AAUE;EACE,cAAA;AARJ;AAWE;EACE,cAAA;EACA,uGAAA;AATJ;AAYE;EACE,cAAA;AAVJ;AAaE;EACE,yDAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;AAeE;EACE,qCAAA;EACA,yHAAA;AAbJ;AAgBE;EACE,qCAAA;AAdJ;AAiBE;EACE,yHAAA;AAfJ;AAkBE;EACE,WAAA;AAhBJ;AAmBE;EACE,sDAAA;AAjBJ;AAoBE;EACE,cAAA;AAlBJ;;AAuBE;EACE;IACE,cAAA;EApBJ;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 1.1rem !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace !important;\n  font-size: 1rem !important;\n}\n\n.main-container {\n  position: relative;\n  background-color: #0d1116;\n\n}\n\na {\n  text-decoration: none;\n}\n\na:hover {\n  color: #5000ca;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out;\n}\n\np, a, h1, h2, h3, h4, h5, label, button {\n  color: white;\n  font-family: \"Lato\", sans-serif;\n}\n\n.navigation-bar {\n  justify-content: space-between;\n  background-color: #0d1116;\n\n  button {\n    font-size: 1.1rem;\n    font-family: \"Lato\", sans-serif;\n    text-transform: initial;\n    padding: 6px 10px;\n  }\n\n  svg {\n    cursor: pointer;\n  }\n}\n\n.navigation-bar-responsive {\n  span, p {\n    color: #0d1116;\n    font-family: \"Lato\", sans-serif;\n  }\n}\n\n.container {\n  margin-top: 64px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.header-image {\n  width: 100%;\n  height: 450px;\n\n  img {\n    width: 100%;\n    height: 450px;\n    object-fit: cover;\n  }\n}\n\n.mobile-menu-top {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  font-weight: bold;\n}\n\n.items-container {\n  padding: 5% 10%;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.light-mode {\n  background-color: #f8f9fa;\n\n  .navigation-bar {\n    background-color: #f8f9fa;\n  }\n\n  p, a, h1, h2, h3, h4, h5, label, button {\n    color: #0d1116;\n  }\n\n  a:hover {\n    color: #5000ca;\n    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out;\n  }\n\n  .navigation-bar svg {\n    color: #0d1116;\n  }\n\n  .about-section {\n    background-image: url(\"./assets/images/bg-light.png\");\n  }\n\n  .skills-container svg {\n    color: #0d1116;\n  }\n\n  .chip {\n    background-color: rgba(0, 0, 0, 0.08);\n    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n  }\n\n  .vertical-timeline::before {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n  }\n\n  .vertical-timeline--two-columns .vertical-timeline-element-content .vertical-timeline-element-date {\n    color: gray;\n  }\n\n  .vertical-timeline-element-content-arrow {\n    border-right: 7px solid rgba(0, 0, 0, 0.08) !important;\n  }\n\n  .flex-chips .chip-title {\n    color: #0d1116;\n  }\n}\n\n@media screen {\n  @media (max-width: 768px) {\n    .items-container {\n      padding: 5% 5%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
